<template>
    <div class="phy_wrap">
       <new-text :text="text"></new-text>
       <div class="phy_top">
            <div class="title">免疫风险等级</div>
            <LevelBar class="risk-status" :active-index="list.brain_level"/>
            <div class="common_title" style="margin-left:16px">10个关联体区基础数值</div>
            <p>线条为正常临界值</p>
            <!-- 柱状图+折线图 -->
            <line-and-bar :barlist="list.brain_tiqu"></line-and-bar>
            <div class="common_title" style="margin-left:16px">左右侧大脑风险数值</div>
            <echarts-bar :barlist="list.brain_about"></echarts-bar>
       </div>
       <div class="phy_cont">
        <div v-for="(desc,index) in list.descArr" :key="index" class="physiology">
          {{desc}}
        </div>
      </div>
    </div>
</template>
<script>
import EchartsBar from '@/components/EchartsBarNxg'
import lineAndBar from "@/components/lineAndBar"
import NewText from "./NewText"
import LevelBar from "./LevelBar"

export default {
    props:[ 'list' ],
    components:{ EchartsBar , lineAndBar, NewText, LevelBar },
    data(){
      return{
        text: '长期睡眠时间不足、睡眠质量差，以及由颈椎问题导致的脑供血不足，都会使得免疫力持续下降，并最终导致脑血管风险增加，应格外重视劳逸结合、心情舒畅，降低脑血管的发生风险。'
      }
    },
}
</script>
<style lang="scss" scoped>
.phy_wrap{
    width: 700px;
    margin: auto;
    
}
.phy_top{
  width: 100%;
  background-color: #fff;
  text-align: center;
  font-size: 30px;
  min-height: 600px;
  padding-top: 30px;
  .risk_sc{
    font-size: 46px;
    color: #DD1008;
  }
  p{
    margin: 30px 0 0px;
    font-size: 32px;
    text-align: left;
    padding-left: 200px;
  }
}
.phy_cont{
  padding:40px 16px;
  background-color: #fff;
  font-size: 32px;
  color: #616161;
  line-height: 36px;
  margin:40px 0;
  text-align: left;
  .common_title{
    font-size: 32px;
    color: #616161;
    margin: 30px 0 25px;
    text-align: left;
    font-weight: bold;
  }
  .physiology{
    padding: 10px 0;
    span{
      font-size: 32px;
      font-weight: bold;
      color: #2E94E5;
    }
  }
}
.risk-status{
  margin:15px auto 0;
  width:350px ;
}
</style>